import React from 'react';
import img1 from '../../assets/img1.jpg';
import img2 from '../../assets/img2.jpg';
import img3 from '../../assets/img3.jpg';

const TeamCultureSection = ({ colors, visibleSections }) => {
  const teamImages = [img1, img2, img3, img1]; // Reusing img1 as placeholder

  return (
    <section 
      className="py-5 performance-optimized" 
      style={{ backgroundColor: colors.primaryLight }}
      data-section="culture"
    >
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 mb-4 mb-lg-0">
            <div 
              className={`border-start border-4 ps-4 mb-4 smooth-reveal ${visibleSections.culture ? 'revealed' : ''}`} 
              style={{ borderColor: `var(--color-primary) !important` }}
            >
              <h2 className="h3 mb-3 fw-bold" style={{ color: `var(--color-primary)`}}>Life at IDLBAY</h2>
              <h3 className="h4" style={{ color: colors.bodyBlack }}>Innovate, Grow, Excel</h3>
            </div>
            
            <div 
              className={`p-4 rounded position-relative card-hover-effect smooth-reveal delay-200 ${visibleSections.culture ? 'revealed' : ''}`}
              style={{ 
                backgroundColor: `var(--color-primary)`,
                color: colors.white 
              }}
            >
              <h4 className="mb-3">Our Work Environment</h4>
              <h6 className="mb-0">
                At IDLBAY, we believe in fostering a dynamic and supportive work environment where talent thrives. 
                We empower our employees to innovate, learn continuously, and make a significant impact on real-world 
                IT challenges. We are committed to a culture of excellence, respect, and shared success.
              </h6>
            </div>
          </div>
          
          <div className="col-lg-6">
            <div className={`position-relative smooth-reveal delay-300 ${visibleSections.culture ? 'revealed' : ''}`}>
              <div className="row g-2 mb-2">
                <div className="col-6">
                  <div className="image-hover-zoom">
                    <img 
                      src={teamImages[0]} 
                      alt="IDLBAY team meeting and brainstorming session for software development projects" 
                      className="img-fluid"
                      style={{
                        borderTopLeftRadius: "30px",
                        borderBottomRightRadius: "30px"
                      }}
                    />
                  </div>
                </div>
                <div className="col-6">
                  <div className="image-hover-zoom">
                    <img 
                      src={teamImages[1]} 
                      alt="IDLBAY team collaboration and teamwork in modern office environment" 
                      className="img-fluid"
                      style={{
                        borderTopLeftRadius: "30px",
                        borderBottomRightRadius: "30px"
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="row g-2">
                <div className="col-6">
                  <div className="image-hover-zoom">
                    <img 
                      src={teamImages[2]} 
                      alt="IDLBAY team workshop and technical training session for IT professionals" 
                      className="img-fluid"
                      style={{
                        borderTopLeftRadius: "30px",
                        borderBottomRightRadius: "30px"
                      }}
                    />
                  </div>
                </div>
                <div className="col-6">
                  <div className="image-hover-zoom">
                    <img 
                      src={teamImages[0]} 
                      alt="IDLBAY team celebration and success achievement in IT company" 
                      className="img-fluid"
                      style={{
                        borderTopLeftRadius: "30px",
                        borderBottomRightRadius: "30px"
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamCultureSection;